import { createSettingsContextProvider } from "@faire/web/common/settings/hooks/createSettingsContextProvider";

export const { useSetting, useAssignSetting, SettingsContextProvider } =
  createSettingsContextProvider<"RETAILER" | "LOGGED_IN_RETAILER">();
